__webpack_require__.p = "{{CDN_URL}}/";